var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames'; // import './anchor-navigation-ink-line.scss';

var AnchorNavigationInkLineProps = function () {
  function AnchorNavigationInkLineProps() {}

  return AnchorNavigationInkLineProps;
}();

export { AnchorNavigationInkLineProps };

var AnchorNavigationInkLine = function (_super) {
  __extends(AnchorNavigationInkLine, _super);

  function AnchorNavigationInkLine() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AnchorNavigationInkLine.prototype.render = function () {
    return React.createElement("div", {
      className: "ant-anchor-ink"
    }, React.createElement("span", {
      ref: "anchorInkNode",
      className: classNames('ant-anchor-ink-line', this.props.activeLink ? 'visible' : '')
    }));
  };
  /**
   * 需要修改指示点的位置
   */


  AnchorNavigationInkLine.prototype.componentDidUpdate = function () {
    var anchorNode = ReactDOM.findDOMNode(this.props.anchorNode);
    if (!anchorNode || !(anchorNode instanceof HTMLElement)) return;
    var linkNode = anchorNode.getElementsByClassName('ant-anchor-link-active')[0];
    if (!linkNode) return;
    this.refs.anchorInkNode.style.height = linkNode.clientHeight + 'px';
    this.refs.anchorInkNode.style.top = linkNode.offsetTop + 'px';
  };

  return AnchorNavigationInkLine;
}(PureComponent);

export { AnchorNavigationInkLine };